import script from "./VerificationCode.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationCode.vue?vue&type=script&setup=true&lang=js"

import "./VerificationCode.vue?vue&type=style&index=0&id=5407a860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5407a860"]])

export default __exports__